import React, { Suspense, lazy } from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';

import { localPaths } from '@mirinae/lessons/modules/defines/paths';
import LoadingSpinner from '@mirinae/react-ui/components/spinner/LoadingSpinner';
// import { ExternalRedirector } from '@mirinae/defines/paths';

const LandingPage = lazy(() => import(/* webpackChunkName: "Landing" */ '@mirinae/lessons/pages/LandingPage'));
const OverviewPage = lazy(() => import(/* webpackChunkName: "Overview" */ '@mirinae/lessons/pages/OverviewPage'));
const QuestionPage = lazy(() => import(/* webpackChunkName: "Question" */ '@mirinae/lessons/pages/QuestionPage'));
const CoursePage = lazy(() => import(/* webpackChunkName: "Course" */ '@mirinae/lessons/pages/CoursePage'));
const SummaryPage = lazy(() => import(/* webpackChunkName: "Summary" */ '@mirinae/lessons/pages/SummaryPage'));
const OneLessonPage = lazy(() => import(/* webpackChunkName: "OneLesson" */ '@mirinae/lessons/pages/OneLessonPage'));
const SearchPage = lazy(() => import(/* webpackChunkName: "Search" */ '@mirinae/lessons/pages/SearchPage'));

const MyLessons = lazy(() => import(/* webpackChunkName: "MyLessons" */ '@mirinae/lessons/pages/MyLessons'));
const Player = lazy(() => import(/* webpackChunkName: "Player" */ '@mirinae/lessons/pages/Player'));
const AdminLessons = lazy(() => import(/* webpackChunkName: "AdminLessons" */ '@mirinae/lessons/pages/AdminLessons'));

const routes = ({isPassByLanding}) => {
    return (
        <Suspense fallback={LoadingSpinner}>
            <Routes>
                <Route path={localPaths.landing} element={<LandingPage />} />
                <Route path={localPaths.admin} element={<AdminLessons />} />
                {/* <Route path={localPaths.home} element={<MyLessons />} /> */}
                <Route path={localPaths.home} element={isPassByLanding ? <OverviewPage /> : <LandingPage />} />
                <Route path={localPaths.question} element={<QuestionPage />} exact />
                <Route path={localPaths.overview} element={<OverviewPage />} exact />
                <Route path={`${localPaths.course}/:groupID/:levelID`} element={<CoursePage />} exact />
                <Route path={localPaths.summary} element={<SummaryPage />} exact />
                <Route path={`${localPaths.onelesson}/:lessonID`} element={<OneLessonPage />} exact />
                <Route path={`${localPaths.search}/:searchText`} element={<SearchPage />} exact />
                <Route path={localPaths.mylessons} element={<MyLessons />} exact />

                <Route path={`${localPaths.player}/:lessonID/:pageID`} element={<Player />} exact />
                <Route path={`${localPaths.player}/:lessonID`} element={<Player />} exact />
                <Route path={localPaths.active} element={<MyLessons />} />
                <Route path={localPaths.complete} element={<MyLessons />} />
                <Route path={localPaths.starter} element={<MyLessons />} />
                <Route path={localPaths.beginner} element={<MyLessons />} />
                <Route path={localPaths.intermediate} element={<MyLessons />} />
                <Route path={localPaths.advanced} element={<MyLessons />} />
                <Route path={localPaths.idiom} element={<MyLessons />} />
                <Route path={localPaths.neologism} element={<MyLessons />} />
                <Route path={localPaths.proverb} element={<MyLessons />} />

                {/*<Route path="*" element={<ExternalRedirector to="/404.html" reload={true}/>} />*/}
                {/* <Route path="*" element={<LandingPage />} /> */}
                <Route path="*" element={<Navigate to='/lessons' reload={true} />}  />
            </Routes>
        </Suspense>
    );
};

export default routes;
